/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetEarlyFinishRequestDetailsForGrid,
    RejectEarlyFinishRequest,
    ApproveEarlyFinishRequestCrop
}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetNewFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetEarlyFinishRequestDetailsForGrid(data) {
    var values = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        farmerID: parseInt(data.farmerID),
        statusID: data.statusID
    }
    const response = await CommonPost('/api/FarmerCropPlot/GetEarlyFinishRequestDetailsForGrid', null, values);
    return response;
}

async function RejectEarlyFinishRequest(data, farmerPlotID, rejectRemark) {
    var values = {
        earlyFinishedCropRequestID: data,
        farmerPlotCropMappingID: farmerPlotID,
        rejectRemark: rejectRemark,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/FarmerCropPlot/RejectEarlyFinishRequest', null, values);
    return response;
}

async function ApproveEarlyFinishRequestCrop(data) {
    var values = {
        earlyFinishedCropRequestID: data.earlyFinishedCropRequestID,
        farmerPlotCropMappingID: data.farmerPlotCropMappingID,
        cropID: data.cropID,
        cropVarietyID: data.cropVarietyID,
        farmerID: data.farmerID,
        productName: data.productName,
        earlyRequestDate: data.earlyRequestDate,
        givenName: data.givenName,
        collectionCenterID: data.collectionCenterID,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/FarmerCropPlot/ApproveEarlyFinishRequestCrop', null, values);
    return response;
}
